__turbopack_context__.v({
  "fadeOut": "Overview-module-scss-module__dJyb9a__fadeOut",
  "hidden": "Overview-module-scss-module__dJyb9a__hidden",
  "readMore": "Overview-module-scss-module__dJyb9a__readMore",
  "summary": "Overview-module-scss-module__dJyb9a__summary",
  "summaryWrapper": "Overview-module-scss-module__dJyb9a__summaryWrapper",
  "title": "Overview-module-scss-module__dJyb9a__title",
});
